const DEFAULT_COUT_PV = [
  { label: 'De 0 à 3 kWc', puissanceMin: 0, puissanceMax: 3, prix: 1900 },
  { label: 'De 3 à 6 kWc', puissanceMin: 3, puissanceMax: 6, prix: 1280 },
  { label: 'De 6 à 9 kWc', puissanceMin: 6, puissanceMax: 9, prix: 1010 },
  { label: 'De 9 à 18 kWc', puissanceMin: 9, puissanceMax: 18, prix: 950 },
  { label: 'De 18 à 36 kWc', puissanceMin: 18, puissanceMax: 36, prix: 830 },
  { label: 'De 36 à 80 kWc', puissanceMin: 36, puissanceMax: 80, prix: 650 },
  { label: 'De 80 à 100 kWc', puissanceMin: 80, puissanceMax: 100, prix: 530 },
  { label: 'De 100 à 180 kWc', puissanceMin: 100, puissanceMax: 180, prix: 510 },
  { label: 'De 180 à 220 kWc', puissanceMin: 180, puissanceMax: 220, prix: 550 },
  { label: 'De 220 à 250 kWc', puissanceMin: 220, puissanceMax: 250, prix: 540 },
  { label: 'De 250 à 300 kWc', puissanceMin: 250, puissanceMax: 300, prix: 520 },
  { label: 'De 300 à 500 kWc', puissanceMin: 300, puissanceMax: 500, prix: 500 },
  { label: 'De 500 à 999 kWc', puissanceMin: 500, puissanceMax: 999, prix: 480 },
  { label: '1000 kWc et plus', puissanceMin: 1000, puissanceMax: null, prix: 480 },
]

const DEFAULT_COUT_BATTERIE = [
  { label: 'De 0 à 9 kWh', puissanceMin: 0, puissanceMax: 9, prix: 585.53 },
  // 585,53 €/kWh comme la tranche de 0 à 9 kWh (correctif du 03/11/2026 ; 251,74 auparavant)
  { label: 'De 9 à 20 kWh', puissanceMin: 9, puissanceMax: 20, prix: 585.53 },
  { label: 'De 20 à 30 kWh', puissanceMin: 20, puissanceMax: 30, prix: 243.03 },
  { label: 'De 30 à 100 kWh', puissanceMin: 30, puissanceMax: 100, prix: 231.72 },
  { label: 'De 100 à 200 kWh', puissanceMin: 100, puissanceMax: 200, prix: 230.51 },
  { label: '200 kWh et plus', puissanceMin: 200, puissanceMax: null, prix: 207.42 },
]

const DEFAULT_COUT_MAINTENANCE = [
  { label: 'De 0 à 9 kWc', puissanceMin: 0, puissanceMax: 9, prix: 275 },
  { label: 'De 9 à 18 kWc', puissanceMin: 9, puissanceMax: 18, prix: 450 },
  { label: 'De 18 à 36 kWc', puissanceMin: 18, puissanceMax: 36, prix: 540 },
  { label: 'De 36 à 100 kWc', puissanceMin: 36, puissanceMax: 100, prix: 650 },
  { label: 'De 100 à 180 kWc', puissanceMin: 100, puissanceMax: 180, prix: 850 },
  { label: 'De 180 à 250 kWc', puissanceMin: 180, puissanceMax: 250, prix: 980 },
  { label: 'De 250 à 300 kWc', puissanceMin: 250, puissanceMax: 300, prix: 1175 },
  { label: 'De 300 à 500 kWc', puissanceMin: 300, puissanceMax: 500, prix: 1375 },
  { label: 'De 500 à 1000 kWc', puissanceMin: 500, puissanceMax: 1000, prix: 1500 },
]

// Défauts calculés depuis l'ancienne formule (coût installation PV / 175), évalués au
// point médian de chaque tranche avec la grille DEFAULT_COUT_PV, puis arrondis. Éditable
// par l'utilisateur en Step 4 — ces valeurs ne sont qu'un point de départ.
const DEFAULT_COUT_ASSURANCE = [
  { label: 'De 0 à 9 kWc', puissanceMin: 0, puissanceMax: 9, prix: 35 },
  { label: 'De 9 à 18 kWc', puissanceMin: 9, puissanceMax: 18, prix: 75 },
  { label: 'De 18 à 36 kWc', puissanceMin: 18, puissanceMax: 36, prix: 130 },
  { label: 'De 36 à 100 kWc', puissanceMin: 36, puissanceMax: 100, prix: 250 },
  { label: 'De 100 à 180 kWc', puissanceMin: 100, puissanceMax: 180, prix: 410 },
  { label: 'De 180 à 250 kWc', puissanceMin: 180, puissanceMax: 250, prix: 675 },
  { label: 'De 250 à 300 kWc', puissanceMin: 250, puissanceMax: 300, prix: 815 },
  { label: 'De 300 à 500 kWc', puissanceMin: 300, puissanceMax: 500, prix: 1145 },
  { label: 'De 500 à 1000 kWc', puissanceMin: 500, puissanceMax: 1000, prix: 2055 },
]

// Câble onduleur ↔ TGBT (19/10/2026) : prix du fichier du BE « Choix Câble.xlsm » (€ HT/m, null = section non proposée),
// considérés comme des prix de vente — mêmes valeurs que CableOnduleur.prixParDefaut côté serveur
export const DEFAULT_PRIX_CABLE = [
  { section: 1.5, alu4: null, alu2: null, cuivre4: 1.22, cuivre2: null },
  { section: 2.5, alu4: null, alu2: null, cuivre4: 1.95, cuivre2: null },
  { section: 4, alu4: null, alu2: null, cuivre4: 2.81, cuivre2: null },
  { section: 6, alu4: null, alu2: null, cuivre4: 4.14, cuivre2: null },
  { section: 10, alu4: null, alu2: null, cuivre4: 6.48, cuivre2: 2.86 },
  { section: 16, alu4: null, alu2: null, cuivre4: 12.95, cuivre2: 4.47 },
  { section: 25, alu4: null, alu2: null, cuivre4: 18.47, cuivre2: 6.5 },
  { section: 35, alu4: 5.68, alu2: 2.5, cuivre4: 28.29, cuivre2: null },
  { section: 50, alu4: 6.74, alu2: 3, cuivre4: 39.51, cuivre2: null },
  { section: 70, alu4: 7.77, alu2: null, cuivre4: null, cuivre2: null },
  { section: 95, alu4: 10.36, alu2: null, cuivre4: null, cuivre2: null },
  { section: 120, alu4: 12.74, alu2: null, cuivre4: null, cuivre2: null },
  { section: 150, alu4: 15.9, alu2: null, cuivre4: null, cuivre2: null },
  { section: 185, alu4: 20.22, alu2: null, cuivre4: null, cuivre2: null },
  { section: 240, alu4: 25.73, alu2: null, cuivre4: null, cuivre2: null },
]
// raccords d'adaptation d'un câble aluminium jusqu'à 36 kVA (8 par câble en triphasé, 4 en monophasé), € HT pièce
export const DEFAULT_RACCORDS_ALU = [
  { label: 'Michaud K127', sectionMin: 25, sectionMax: 95, prix: 39 },
  { label: 'Michaud K126', sectionMin: 95, sectionMax: 240, prix: 79 },
]

/**
 * Une étape enregistre ses champs en la quittant : seule une vraie modification rend l'étude « à recalculer »
 * (12/10/2026 : parcourir une étude calculée sans rien changer laisse le rapport accessible).
 */
// valeurs recalculées par les étapes (pas des saisies) : elles ne rendent pas l'étude « à recalculer »
const VALEURS_DERIVEES = new Set(['consommationAnnuelleKwh', 'estimationFactureAnnuelle'])

export function changeQuelqueChose(state: any, data: any): boolean {
  const norm = (v: any) => (v === undefined || v === '' ? null : v)
  return Object.keys(data).some(k => {
    if (VALEURS_DERIVEES.has(k)) return false
    const avant = norm(state[k]), apres = norm(data[k])
    if (avant === apres) return false
    if (typeof File !== 'undefined' && (avant instanceof File || apres instanceof File)) return avant !== apres
    return JSON.stringify(avant) !== JSON.stringify(apres)
  })
}

// TVA sur l'électricité : les prix sont saisis HT ; un particulier est facturé TTC (règle du 12/10/2026,
// comme WizardService.TVA_ELECTRICITE côté serveur).
/** Choix du chiffrage au matériel (23/10/2026) : références du catalogue, vides = premier article. */
// panneau : choisi en Step 2 (panneauCatalogue) ; marque / gamme d'onduleurs : professionnel (27/10/2026), vides = les moins chers
// professionnel (28/10/2026) : kits de la marque (kits) ; backup partiel, câble selon la longueur du câble onduleur ↔ TGBT
// le plus rentable ou le matériel préféré (02/11/2026) : integration '*' = la moins chère au Wc ; marqueOnduleur = fabricant
// des onduleurs réseau, systemeBatterie = onduleurs hybrides et batteries ('FOX ESS', 'kit:FOX ESS') ; vides = le plus rentable
// 03/11/2026 (réunion avec Maxime) : système d'intégration choisi pour chaque toiture en Step 2 (integration ne sert plus
// qu'aux études d'avant) ; options de la Step 4 : extension de garantie des onduleurs (5 = de base), shelter (pro), bornes de
// charge [{ ref, nombre }], ombrières posées par nous, bac acier fourni et posé (pro) ; marges des sections prestations et bornes
export const DEFAULT_MATERIEL = { typePro: 'ict', panneau: '', integration: '', optimiseurs: false, backup: false, ajustementPct: 0,
  marqueOnduleur: '', gammeOnduleur: '', kits: false, ratioReseau: null, ratioHybride: null,
  margeMaterielPct: null, margeBatteriePct: null, systemeBatterie: '',
  garantieOnduleurAns: 5, shelter: false, bornes: [] as any[], ombriereParNous: true, bacAcier: false, bacAcierM2: null,
  margePrestaPct: null, margeBornesPct: null }

/** Typologies de projet (03/11/2026) : une par toiture ; ombrière pour un professionnel, carport pour un particulier. */
export const TYPOLOGIES = [
  { valeur: 'inclinee', libelle: 'Toiture inclinée', pose: 'roof' },
  { valeur: 'terrasse', libelle: 'Toiture terrasse', pose: 'roof' },
  // toiture inclinée, panneaux intégrés au bâti (03/11/2026) : remplace le type de pose « intégré au bâti »
  { valeur: 'bipv', libelle: 'Toiture BIPV (intégrée au bâti)', pose: 'building' },
  { valeur: 'sol', libelle: 'Centrale au sol', pose: 'free' },
  { valeur: 'ombriere', libelle: 'Ombrière', pose: 'free', pro: true },
  { valeur: 'carport', libelle: 'Carport', pose: 'free', particulier: true },
]

export function typologiesPour(particulier: boolean): any[] {
  return TYPOLOGIES.filter((t: any) => particulier ? !t.pro : !t.particulier)
}

export const TVA_ELECTRICITE = 0.20
/** TVA d'un particulier sur les travaux supplémentaires : toujours 20 % (règle du 20/10/2026, WizardService.TVA_TRAVAUX_PCT). */
export const TVA_TRAVAUX = 0.20
/** TVA d'un particulier sur la batterie : toujours 20 %, même avec un onduleur hybride (règle du 27/10/2026, WizardService.TVA_BATTERIE_PCT). */
export const TVA_BATTERIE = 0.20
/** Puissance minimale d'une étude professionnelle (kWc, règle du 27/10/2026, WizardService.KWC_MIN_PRO). */
export const KWC_MIN_PRO = 9

// Raccordement pré-rempli en Step 3 (règle du 08/10/2026) : monophasé jusqu'à 12 kVA, triphasé au-delà.
// Modifiable : pas de minimum en triphasé, et de vieilles maisons sont en monophasé au-delà de 12 kVA.
export function raccordementParDefaut(kva: any): string | null {
  const n = typeof kva === 'string' ? parseFloat(kva.replace(',', '.')) : kva
  if (n === null || n === undefined || isNaN(n) || n <= 0) return null
  return n <= 12 ? 'mono' : 'tri'
}

export function libelleRaccordement(r: any): string {
  return r === 'tri' ? 'triphasé' : r === 'mono' ? 'monophasé' : ''
}

// Version du schéma du wizardJson. À incrémenter à chaque évolution structurelle
// (champ renommé, supprimé, ou changement de structure des tranches).
// Chaque palier doit avoir un bloc de migration dans RESTORE_DRAFT.
// Historique :
//   v0 : état initial (pas de schemaVersion)
//   v1 : renommage turpe → taxeelec
//   v2 : mergeTranches met à jour puissanceMax/label des tranches existantes
//   v3 : ajout de la grille coutAssurance (remplace la formule fixe d'assurance)
//   v4 : coût de raccordement Enedis saisi en € (k€ auparavant, 12/10/2026)
//   v5 : interrupteur propre pour l'assurance (avecAssurance, 13/10/2026 ; avant : celui de la maintenance)
//   v6 : études de particuliers enregistrées par l'ancienne version (schéma < 4) : prix de l'électricité saisis TTC,
//        ramenés en HT (÷ 1,20) et rapport recalculé à la réouverture (13/10/2026)
export const WIZARD_SCHEMA_VERSION = 6

/** Prix de l'électricité d'une étude (c€/kWh, sauf l'abonnement en €/an). */
export const CHAMPS_PRIX_ELECTRICITE = ['tarifHP', 'tarifHC', 'tarifHSC', 'tarifHPHiver', 'tarifHCHiver', 'tarifHSCHiver',
  'tarifHPEte', 'tarifHCEte', 'tarifHSCEte', 'taxeelec', 'tarifAbonnementAnnuel']

export function buildInitialState() {
  return {
    schemaVersion: WIZARD_SCHEMA_VERSION,
    currentStep: 1,
    recalculAuto: false, // rapport à recalculer à la réouverture (prix convertis en HT, v6) — non enregistré
    etapeAtteinte: 1, // étape la plus loin déjà atteinte : on peut y revenir sans repasser par « Suivant » (12/10/2026)

    // Étape 1 — Projet
    projectName: '',
    clientType: 'Particulier',
    raisonSociale: '',
    clientLastName: '',
    clientFirstName: '',
    clientTelephone: '',
    clientEmail: '',
    address: '',
    rue: '',
    codePostal: '',
    ville: '',
    latitude: null,
    longitude: null,

    // Étape 2 — Toiture
    surfaceM2: null,
    modeleProduction: 'pvgis',  // 'pvgis' (défaut depuis le lot 15) | 'db' (modèle Systèmes Solaires)
    orientation: 'Sud',         // modèle DB : 'Sud' | 'Est-Ouest' | 'Est ou Ouest'
    orientationDegres: 180,     // modèle PVGIS mono-toiture (non utilisé en mode multi)
    mountingplace: 'roof',      // 'roof' (surimposition, toiture inclinée ou plate depuis le 27/10/2026 ; défaut du 12/10/2026) | 'free' (au sol, ombrière) | 'building' (BIPV)
    pertesSysteme: 14,          // pertes du système envoyées à PVGIS, en % (lot 15 ; 14 % depuis le 13/10/2026, conseil PVGIS et pertes détaillées du BE ; 10 % auparavant)
    inclinaisonDeg: 30,
    puissanceModuleWc: 490,     // valeurs par défaut du 09/10/2026 (400 Wc / 1,74 m² auparavant)
    tailleModuleM2: 2.10,     // 2,10 m² depuis le 20/10/2026 (retour commercial ; 2,01 auparavant)
    panneauCatalogue: '',     // panneau du catalogue du matériel choisi en Step 2 (27/10/2026) ; vide = saisie libre
    puissanceTotaleKwc: 0,
    toitures: [] as any[],      // mode PVGIS multi-toitures : [{ surfaceM2, inclinaisonDeg, orientationDegres, mountingplace }]
    pvRangeMin: null,
    pvRangeMax: null,
    batRangeMin: 5,
    batRangeMax: 25,
    savedPvgisStats: null,        // PvgisStatsDto combiné — persisté dans le draft
    savedDbStats: null,           // PvgisStatsDto — persisté dans le draft
    savedPvgisBreakdown: null,    // breakdown multi-toitures — persisté dans le draft
    pvProfileId: null,            // ID du profil PV persisté en DB (user_pv_profile)

    // Draft
    draftId: null,
    consumptionCurveId: null,
    consumptionCurveStatus: 'none', // 'none' | 'uploading' | 'saved' | 'error'

    // Étape 3 — Consommation
    typeTarif: 'hchp',  // 'unique' | 'hchp' | 'saisonnier'
    puissanceAbonnement: null,
    raccordement: null,  // 'mono' | 'tri' — pré-rempli d'après la puissance souscrite (raccordementParDefaut), modifiable
    profileSource: null,  // choisi en Step 3 ; par défaut PDL pour un particulier, import de fichier pour un pro (13/10/2026)
    profilPredifini: 'maison_4pers',
    csvFile: null,
    nomFichierCourbe: '',  // nom du fichier CSV importé, affiché à la réouverture (23/10/2026) ; vide pour une courbe Enedis ou un profil type
    tarifAbonnementAnnuel: null,
    tarifHP: null,
    tarifHC: null,
    tarifHPHiver: null,
    tarifHCHiver: null,
    tarifHPEte: null,
    tarifHCEte: null,
    taxeelec: null,
    periodesHC: [{ debut: '22:00', fin: '06:00' }],
    // heures super creuses (lot 8, TODO du 02/10/2026) : types « hsc » et « hsc_saisonnier »
    tarifHSC: null,
    tarifHSCHiver: null,
    tarifHSCEte: null,
    periodesHSC: [] as any[],
    periodesHCEte: [] as any[],
    periodesHCHiver: [] as any[],
    periodesHSCEte: [] as any[],
    periodesHSCHiver: [] as any[],
    pdlNumber: '',
    enedisConsentCode: '',
    pdlStartDate: '',
    pdlEndDate: '',
    consommationAnnuelleKwh: 0,
    estimationFactureAnnuelle: 0,

    // Étape 4 — Paramètres
    nomRapport: '',
    tauxTva: 20,
    avecFinancement: false,
    inflationElec: 3.5,             // 3,5 %/an (comme le bureau d'études, 09/10/2026 ; 4 % auparavant)
    capaciteUtilisableBatterie: 90, // lot 17 : % de la capacité de batterie utilisée
    degradationPanneaux: 0.4,
    degradationBatterie: 2,
    rendementBatterie: 90,
    rendementConversionBatterie: 98,
    coutInstallationPV: JSON.parse(JSON.stringify(DEFAULT_COUT_PV)),
    coutInstallationBatterie: JSON.parse(JSON.stringify(DEFAULT_COUT_BATTERIE)),
    rachatSurplusUnitaire: 0.011,   // 1,1 c€/kWh (décision du 09/10/2026 ; 11 c€ auparavant)
    zeroInjection: true,            // zéro-injection par défaut (décision du 09/10/2026)
    coutRaccordementEnedis: 0,
    travauxSupplementaires: 0,           // € HT (TODO du 02/10/2026)
    travauxSupplementairesLibelle: '',
    prixDatalogger: null,                // € HT saisi en Step 4 (13/10/2026) ; null = selon la puissance d'abonnement
    longueurCable: null,                 // m — câble onduleur ↔ TGBT (19/10/2026) ; vide = non chiffré
    erp: false,                          // établissement recevant du public (pro) : câble majoré de 30 % (27/10/2026)
    prixCable: JSON.parse(JSON.stringify(DEFAULT_PRIX_CABLE)),
    prixRaccordsAlu: JSON.parse(JSON.stringify(DEFAULT_RACCORDS_ALU)),
    // chiffrage au matériel (fichier de coûts de Maxime, 23/10/2026, provisoire) : remplace les grilles PV et batterie
    // 03/11/2026 : toujours chiffrée au matériel (plus d'interrupteur) ; une étude d'avant garde ses grilles
    chiffrageMateriel: true,
    materiel: { ...DEFAULT_MATERIEL, bornes: [] },
    // Step 2, modèle Systèmes Solaires (une toiture) : typologie, système d'intégration, nombre de carports
    typologie: 'inclinee',
    integrationToiture: '',
    unitesCarport: 1,
    avecMaintenance: true,          // maintenance et assurance comptées par défaut (09/10/2026, étude COLOMBEL)
    avecAssurance: true,            // interrupteur propre depuis le 13/10/2026
    coutMaintenance: JSON.parse(JSON.stringify(DEFAULT_COUT_MAINTENANCE)),
    coutAssurance: JSON.parse(JSON.stringify(DEFAULT_COUT_ASSURANCE)),
    // évolution des OPEX (règle du 08/10/2026) : maintenance +2 % tous les 5 ans, assurance +1,5 %/an
    hausseMaintenancePct: 2,
    hausseMaintenancePeriode: 5,
    inflationAssurance: 1.5,
    apportPct: 20,
    tauxEmprunt: 4.5,
    dureeEmprunt: 10,
    dureeEmpruntAuPlusCourt: false, // durée calculée par scénario (26/10/2026)

    // Indique si les paramètres ont été modifiés depuis le dernier calcul
    dirty: false,

    // Étape 5 — Calcul
    calculStatus: 'idle',
    calculProgress: 0,
    calculMessage: '',

    // Étape 6 — Résultats (deux scénarios : avec et sans batterie)
    simulationResult: null,       // résultat actif (toggle ou cellule matrice sélectionnée)
    resultSansBatterie: null,     // meilleur ROI sans batterie
    resultAvecBatterie: null,     // meilleur ROI avec batterie
    matrixResults: null,          // liste des cellules WizardMatrixCell
    selectedMatrixCell: null,     // cellule sélectionnée dans la matrice {kWc, kWh}
    availableBatteryKwh: null,    // capacités catalogue dans la plage choisie ([] = aucune)

    // IDs sauvegardés en BDD
    customerId: null,
    simulationId: null,
  }
}

export default {
  namespaced: true,
  state: buildInitialState,
  mutations: {
    SET_STEP(state: any, step: any) {
      state.currentStep = step
      state.etapeAtteinte = Math.max(state.etapeAtteinte || 1, step)
    },
    SET_RECALCUL_AUTO(state: any, valeur: boolean) {
      state.recalculAuto = !!valeur
    },
    SET_ETAPE_ATTEINTE(state: any, etape: number) {
      state.etapeAtteinte = Math.max(1, etape || 1)
    },
    SET_DIRTY(state: any, value: boolean) {
      state.dirty = value
    },
    CLEAR_RESULTS(state: any) {
      state.resultSansBatterie = null
      state.resultAvecBatterie = null
      state.matrixResults = null
      state.availableBatteryKwh = null
      state.selectedMatrixCell = null
      state.simulationResult = null
    },
    SET_STEP1(state: any, data: any) {
      const modifie = changeQuelqueChose(state, data)
      // Nouvelle position (adresse ou repère déplacé sur la carte) : le profil PVGIS, calculé pour l'ancienne
      // latitude / longitude, est effacé — la Step 2 demande de le recalculer.
      const deplace = (k: string) => data[k] !== undefined && data[k] !== null && state[k] !== null && data[k] !== state[k]
      if ((deplace('latitude') || deplace('longitude')) && state.modeleProduction === 'pvgis') {
        state.savedPvgisStats = null
        state.savedPvgisBreakdown = null
        state.pvProfileId = null
      }
      Object.assign(state, data)
      if (modifie) state.dirty = true
    },
    SET_STEP2(state: any, data: any) {
      const modifie = changeQuelqueChose(state, data)
      // nouvelle puissance installable : la plage PV de la Step 4 (déduite de l'ancienne) est recalculée (bug du 08/10/2026)
      if (data.puissanceTotaleKwc !== undefined && state.puissanceTotaleKwc && data.puissanceTotaleKwc !== state.puissanceTotaleKwc) {
        state.pvRangeMin = null
        state.pvRangeMax = null
      }
      Object.assign(state, data)
      if (modifie) state.dirty = true
    },
    SET_STEP3(state: any, data: any) {
      const modifie = changeQuelqueChose(state, data)
      Object.assign(state, data)
      if (modifie) state.dirty = true
    },
    SET_STEP4(state: any, data: any) {
      const modifie = changeQuelqueChose(state, data)
      Object.assign(state, data)
      if (modifie) state.dirty = true
    },
    SET_PRODUCTION_STATS(state: any, payload: any) {
      if (payload.pvgisStats !== undefined) state.savedPvgisStats = payload.pvgisStats
      if (payload.dbStats !== undefined) state.savedDbStats = payload.dbStats
      if (payload.pvgisBreakdown !== undefined) state.savedPvgisBreakdown = payload.pvgisBreakdown
    },
    SET_PV_PROFILE_ID(state: any, id: any) {
      state.pvProfileId = id
    },
    SET_CALCUL(state: any, payload: any) {
      state.calculStatus = payload.status
      if (payload.progress !== undefined) state.calculProgress = payload.progress
      if (payload.message !== undefined) state.calculMessage = payload.message
    },
    SET_RESULT(state: any, bothResults: any) {
      // bothResults = { sansBatterie: {...}, avecBatterie: {...}, matrix: [...] }
      state.resultSansBatterie = bothResults.sansBatterie || null
      state.resultAvecBatterie = bothResults.avecBatterie || null
      state.matrixResults = bothResults.matrix || null
      state.availableBatteryKwh = bothResults.availableBatteryKwh || []
      state.selectedMatrixCell = null
      // résultat actif par défaut = meilleur ROI
      const sb = bothResults.sansBatterie
      const ab = bothResults.avecBatterie
      if (sb && ab) {
        // ROI ≤ 0 = non rentable (12/10/2026 : rapport produit quand même) : un scénario rentable l'emporte,
        // sinon celui aux meilleures économies nettes
        const nettes = (r: any) => (r.economiesAn1 || 0) - (r.maintenanceAnnuelle || 0) - (r.assuranceAnnuelle || 0)
        const rs = sb.roi > 0, ra = ab.roi > 0
        state.simulationResult = rs !== ra ? (rs ? sb : ab) : (rs ? (sb.roi <= ab.roi ? sb : ab) : (nettes(sb) >= nettes(ab) ? sb : ab))
      } else {
        state.simulationResult = sb || ab
      }
      state.calculStatus = 'done'
      state.calculProgress = 100
      state.dirty = false
    },
    SET_MATRIX_CELL(state: any, cell: any) {
      state.selectedMatrixCell = cell ? { kWc: cell.kwc, kWh: cell.kwh } : null
      state.simulationResult = cell && cell.result ? cell.result : state.simulationResult
    },
    SET_DRAFT_ID(state: any, id: any) {
      state.draftId = id
    },
    SET_CONSUMPTION_CURVE_ID(state: any, payload: any) {
      state.consumptionCurveId = payload ? payload.id : null
      state.consumptionCurveStatus = payload ? (payload.status || 'saved') : 'none'
      // nom du fichier : donné par l'import CSV, effacé par une autre source (Enedis, profil type) ; gardé si non précisé
      if (!payload) state.nomFichierCourbe = ''
      else if (payload.nomFichier !== undefined) state.nomFichierCourbe = payload.nomFichier
    },
    RESTORE_DRAFT(state: any, data: any) {
      // Restaure tous les champs sérialisables depuis le JSON du draft
      // (csvFile exclu car non sérialisable)
      const skip = new Set(['csvFile', 'simulationResult', 'resultSansBatterie', 'resultAvecBatterie',
                            'matrixResults', 'selectedMatrixCell', 'calculStatus', 'calculProgress', 'calculMessage'])
      Object.keys(data).forEach(k => {
        if (!skip.has(k)) {
          state[k] = data[k]
        }
      })

      // -----------------------------------------------------------------------
      // Migrations séquentielles — à compléter à chaque évolution structurelle.
      // Les migrations s'appliquent en cascade : un draft v0 passe par v1 puis v2, etc.
      // Pour ajouter une migration vN → vN+1 :
      //   1. Ajouter un bloc `if (fromVersion < N+1) { ... }` ci-dessous
      //   2. Incrémenter WIZARD_SCHEMA_VERSION en haut du fichier
      //   3. Documenter dans le commentaire de WIZARD_SCHEMA_VERSION
      // -----------------------------------------------------------------------
      const fromVersion = data.schemaVersion || 0

      // v0 → v1 : renommage turpe → taxeelec
      if (fromVersion < 1 && data.turpe !== undefined) {
        state.taxeelec = data.turpe
      }

      // v3 → v4 : coût de raccordement en € (k€ auparavant)
      if (fromVersion < 4 && typeof state.coutRaccordementEnedis === 'number') {
        state.coutRaccordementEnedis = Math.round(state.coutRaccordementEnedis * 1000 * 100) / 100
      }
      // v4 → v5 : l'assurance suivait l'interrupteur de la maintenance
      if (fromVersion < 5 && data.avecAssurance === undefined) {
        state.avecAssurance = data.avecMaintenance !== undefined ? !!data.avecMaintenance : true
      }
      // v5 → v6 : l'ancienne version (schéma < 4, jusqu'au 12/10/2026) faisait saisir les prix TTC pour un particulier ;
      // tout se saisit HT désormais (TVA ajoutée par RETIX) → prix ÷ 1,20 et rapport recalculé à la réouverture
      state.recalculAuto = false
      if (fromVersion < 4 && data.clientType === 'Particulier') {
        CHAMPS_PRIX_ELECTRICITE.forEach(k => {
          if (typeof state[k] === 'number') {
            const decimales = k === 'tarifAbonnementAnnuel' ? 100 : 10000
            state[k] = Math.round(state[k] / (1 + TVA_ELECTRICITE) * decimales) / decimales
          }
        })
        state.recalculAuto = true
      }
      // puissance d'abonnement de l'ancienne liste déroulante, enregistrée en texte (« 36 kVA ») : le calcul la refusait
      // (« Internal server error », constaté le 21/10/2026 sur 5 études de juillet-septembre) → nombre de kVA
      if (typeof state.puissanceAbonnement === 'string') {
        const kva = parseFloat(state.puissanceAbonnement.replace(',', '.'))
        state.puissanceAbonnement = isNaN(kva) ? null : kva
      }
      // le brouillon est désormais au schéma courant : les migrations ne seront pas rejouées
      state.schemaVersion = WIZARD_SCHEMA_VERSION

      // v1 → v2 : mergeTranches étendu (pas de migration de données — appliqué systématiquement)
      // v2 → v3 : ajout coutAssurance (pas de migration de données — initialisé par mergeTranches ci-dessous)

      // Puissance souscrite (B05, toujours appliquée, idempotente) : avant le 9 juillet 2026 elle était choisie dans une
      // liste et stockée en texte (« 36 kVA ») ; le champ est désormais numérique (36)
      if (typeof state.puissanceAbonnement === 'string') {
        const n = parseFloat(state.puissanceAbonnement.replace(',', '.'))
        state.puissanceAbonnement = isNaN(n) ? null : n
      }

      // -----------------------------------------------------------------------
      // Synchronisation des grilles de coût (toujours appliquée, idempotente) :
      // - met à jour les bornes (puissanceMax, label) des tranches existantes si elles ont changé
      // - ajoute les nouvelles tranches absentes du draft
      // - conserve le prix personnalisé par l'utilisateur
      // -----------------------------------------------------------------------
      const mergeTranches = (saved: any[], defaults: any[]) => {
        if (!saved || !saved.length) return JSON.parse(JSON.stringify(defaults))
        const defaultByMin = new Map(defaults.map((t: any) => [t.puissanceMin, t]))
        const updated = saved.map((t: any) => {
          const d = defaultByMin.get(t.puissanceMin)
          if (d && (t.puissanceMax !== d.puissanceMax || t.label !== d.label)) {
            return { ...t, puissanceMax: d.puissanceMax, label: d.label }
          }
          return t
        })
        const savedMins = new Set(updated.map((t: any) => t.puissanceMin))
        const missing = defaults.filter((t: any) => !savedMins.has(t.puissanceMin))
        return missing.length ? [...updated, ...missing] : updated
      }
      state.coutInstallationPV = mergeTranches(state.coutInstallationPV, DEFAULT_COUT_PV)
      state.coutInstallationBatterie = mergeTranches(state.coutInstallationBatterie, DEFAULT_COUT_BATTERIE)
      state.coutMaintenance = mergeTranches(state.coutMaintenance, DEFAULT_COUT_MAINTENANCE)
      state.coutAssurance = mergeTranches(state.coutAssurance, DEFAULT_COUT_ASSURANCE)
      // câble onduleur ↔ TGBT (19/10/2026) : étude antérieure sans grille → prix du fichier du BE
      if (!Array.isArray(state.prixCable) || !state.prixCable.length) state.prixCable = JSON.parse(JSON.stringify(DEFAULT_PRIX_CABLE))
      if (!Array.isArray(state.prixRaccordsAlu) || !state.prixRaccordsAlu.length) state.prixRaccordsAlu = JSON.parse(JSON.stringify(DEFAULT_RACCORDS_ALU))
      if (data.longueurCable === undefined) state.longueurCable = null
      if (data.erp === undefined) state.erp = false
      if (data.panneauCatalogue === undefined) state.panneauCatalogue = ''
      if (data.dureeEmpruntAuPlusCourt === undefined) state.dureeEmpruntAuPlusCourt = false
      // chiffrage au matériel (23/10/2026) : étude antérieure → grilles
      if (data.chiffrageMateriel === undefined) state.chiffrageMateriel = false
      state.materiel = { ...DEFAULT_MATERIEL, ...(data.materiel || {}) }
      if (!Array.isArray(state.materiel.bornes)) state.materiel.bornes = []
      if (data.typologie === undefined) state.typologie = 'inclinee'
      if (data.integrationToiture === undefined) state.integrationToiture = (data.materiel && data.materiel.integration) || ''
      if (data.unitesCarport === undefined) state.unitesCarport = 1
      // panneau « le plus rentable » (02/11/2026) : plus proposé depuis le 03/11/2026, résolu par le serveur pour cette étude
      // type de pose « intégré au bâti » d'une toiture inclinée : typologie BIPV (03/11/2026)
      if (data.typologie === undefined && data.mountingplace === 'building') state.typologie = 'bipv'
      if (Array.isArray(state.toitures)) state.toitures.forEach((t: any) => {
        if (t.typologie === undefined) t.typologie = t.mountingplace === 'building' ? 'bipv' : 'inclinee'
        else if (t.typologie === 'inclinee' && t.mountingplace === 'building') t.typologie = 'bipv'
        if (t.integration === undefined) t.integration = (data.materiel && data.materiel.integration) || ''
        if (t.unites === undefined) t.unites = 1
      })
      // onduleurs hybrides et batteries (02/11/2026) : étude antérieure → batteries de la marque des onduleurs, comme avant ;
      // fixation : le premier système du catalogue, comme avant
      if (!data.materiel || data.materiel.systemeBatterie === undefined) state.materiel.systemeBatterie = state.materiel.marqueOnduleur || ''
      if (data.materiel && data.materiel.integration === undefined) state.materiel.integration = ''

    },
    SET_ACTIVE_RESULT(state: any, withBattery: boolean) {
      if (withBattery && state.resultAvecBatterie) {
        state.simulationResult = state.resultAvecBatterie
      } else if (!withBattery && state.resultSansBatterie) {
        state.simulationResult = state.resultSansBatterie
      }
    },
    SET_IDS(state: any, ids: any) {
      if (ids.customerId !== undefined) state.customerId = ids.customerId
      if (ids.simulationId !== undefined) state.simulationId = ids.simulationId
    },
    // valeurs par défaut du catalogue pour une nouvelle étude (30/10/2026) : ne marque pas l'étude comme modifiée
    APPLIQUER_DEFAUTS(state: any, defauts: any) {
      Object.keys(defauts || {}).forEach(k => {
        if (k in state) state[k] = defauts[k]
      })
    },
    RESET(state: any) {
      const fresh = buildInitialState()
      Object.keys(fresh).forEach(k => {
        state[k] = fresh[k]
      })
    },
  },
  getters: {
    currentStep: (state: any) => state.currentStep,
    isStepComplete: (state: any) => (step: any) => state.currentStep > step,
    nomRapportDefault: (state: any) => {
      if (state.nomRapport) return state.nomRapport
      const parts = []
      if (state.clientLastName) parts.push(state.clientLastName)
      if (state.projectName) parts.push(state.projectName)
      return parts.length > 0 ? parts.join(' - ') + ' - Rapport' : 'Rapport'
    },
  },
}
